/**
 * Mobile Menu Functionality
 * Handles the hamburger menu toggle for mobile devices
 */
(function() {
    'use strict';

    // Wait for DOM to be ready
    document.addEventListener('DOMContentLoaded', function() {
        const hamburgerToggle = document.querySelector('.hamburger-menu-toggle');
        const headerMenu = document.getElementById('header-menu');
        const mobileCloseBtn = document.querySelector('.mobile-close-btn');
        const body = document.body;

        // Debug logging
        console.log('Mobile menu script loaded');
        console.log('Hamburger toggle found:', hamburgerToggle);
        console.log('Header menu found:', headerMenu);
        console.log('Mobile close button found:', mobileCloseBtn);

        // Return early if elements don't exist
        if (!hamburgerToggle || !headerMenu) {
            console.log('Required elements not found, exiting mobile menu script');
            return;
        }

        // Toggle menu function
        function toggleMobileMenu() {
            const isOpen = hamburgerToggle.classList.contains('active');
            console.log('Toggle menu called, current state:', isOpen ? 'open' : 'closed');
            
            if (isOpen) {
                // Close menu
                hamburgerToggle.classList.remove('active');
                headerMenu.classList.remove('mobile-menu-open');
                hamburgerToggle.setAttribute('aria-expanded', 'false');
                body.style.overflow = '';
                console.log('Menu closed');
            } else {
                // Open menu
                hamburgerToggle.classList.add('active');
                headerMenu.classList.add('mobile-menu-open');
                hamburgerToggle.setAttribute('aria-expanded', 'true');
                body.style.overflow = 'hidden'; // Prevent background scrolling
                console.log('Menu opened');
            }
        }

        // Add click event to hamburger button
        hamburgerToggle.addEventListener('click', toggleMobileMenu);
        console.log('Click event added to hamburger button');

        // Add click event to mobile close button
        if (mobileCloseBtn) {
            mobileCloseBtn.addEventListener('click', function() {
                hamburgerToggle.classList.remove('active');
                headerMenu.classList.remove('mobile-menu-open');
                hamburgerToggle.setAttribute('aria-expanded', 'false');
                body.style.overflow = '';
                console.log('Menu closed via close button');
            });
            console.log('Click event added to mobile close button');
        }

        // Close menu when clicking on a menu item
        const menuLinks = headerMenu.querySelectorAll('a');
        menuLinks.forEach(function(link) {
            link.addEventListener('click', function() {
                hamburgerToggle.classList.remove('active');
                headerMenu.classList.remove('mobile-menu-open');
                hamburgerToggle.setAttribute('aria-expanded', 'false');
                body.style.overflow = '';
                console.log('Menu closed via link click');
            });
        });

        // Close menu when clicking outside
        document.addEventListener('click', function(event) {
            const isClickInsideMenu = headerMenu.contains(event.target);
            const isClickOnToggle = hamburgerToggle.contains(event.target);
            
            if (!isClickInsideMenu && !isClickOnToggle && headerMenu.classList.contains('mobile-menu-open')) {
                hamburgerToggle.classList.remove('active');
                headerMenu.classList.remove('mobile-menu-open');
                hamburgerToggle.setAttribute('aria-expanded', 'false');
                body.style.overflow = '';
                console.log('Menu closed via outside click');
            }
        });

        // Handle window resize - close menu if screen becomes larger than mobile breakpoint
        window.addEventListener('resize', function() {
            if (window.innerWidth > 959 && headerMenu.classList.contains('mobile-menu-open')) {
                hamburgerToggle.classList.remove('active');
                headerMenu.classList.remove('mobile-menu-open');
                hamburgerToggle.setAttribute('aria-expanded', 'false');
                body.style.overflow = '';
                console.log('Menu closed via resize');
            }
        });

        // Handle escape key
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && headerMenu.classList.contains('mobile-menu-open')) {
                hamburgerToggle.classList.remove('active');
                headerMenu.classList.remove('mobile-menu-open');
                hamburgerToggle.setAttribute('aria-expanded', 'false');
                body.style.overflow = '';
                console.log('Menu closed via escape key');
            }
        });
    });
})(); 